import request from '@/utils/request'

/**
 * 获取用户优惠券统计列表
 * @param {Object} query - 查询参数对象，可包含whType字段
 * @returns {Promise} - 返回一个Promise对象，包含请求结果
 */
export function getUserCouponStatList(query) {
  // 根据whType选择不同的接口
  const url = query.whType === 30
    ? 'coupon/coupon-use-record/page/tenant'
    : 'coupon/coupon-use-record/page'

  return request({
    url: url, // 请求的API端点，优惠券统计相关接口
    method: 'get', // 请求方法为GET，用于获取数据
    params: query, // 将查询参数添加到请求中，用于筛选和分页等
  })
}
